var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCadeado01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "ico-cadeado-2",
    d: "M27.9,13.6h-1.1V9.2c0-4.8-3.9-8.8-8.8-8.8S9.2,4.4,9.2,9.2v4.4H8.1c-1.8,0-3.3,1.5-3.3,3.3v15.3 c0,1.8,1.5,3.3,3.3,3.3h19.7c1.8,0,3.3-1.5,3.3-3.3V16.9C31.1,15.1,29.7,13.6,27.9,13.6z M12.2,9.2c0-3.2,2.6-5.8,5.8-5.8 c3.2,0,5.8,2.6,5.8,5.8v4.4H12.2V9.2z M19.5,24.9v3.3c0,0.8-0.6,1.5-1.4,1.5s-1.5-0.6-1.5-1.4c0,0,0-0.1,0-0.1v-3.3 c-1.4-0.8-1.9-2.6-1.1-4c0.8-1.4,2.6-1.9,4-1.1c1.4,0.8,1.9,2.6,1.1,4C20.3,24.3,19.9,24.6,19.5,24.9L19.5,24.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCadeado01);
export default __webpack_public_path__ + "static/media/ico-cadeado-01.aa860f7cc1f71872c36d1fbf8bc9f6cf.svg";
export { ForwardRef as ReactComponent };